export {isVirtualClick, isVirtualPointerEvent} from '../../../src/utils/isVirtualEvent';
